import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApple = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 14.461C20 12.461 20.646 10.688 22.479 10",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M28.868 14.937C28.1871 14.0871 27.2552 13.474 26.2052 13.1853C25.1551 12.8965 24.0407 12.9468 23.021 13.329L20 14.461L16.979 13.329C16.1339 13.0118 15.2203 12.9216 14.3294 13.0676C13.4385 13.2135 12.6015 13.5905 11.9017 14.1608C11.202 14.7312 10.664 15.475 10.3413 16.3181C10.0187 17.1612 9.92276 18.0742 10.063 18.966L11.749 27.754C11.8416 28.3363 12.0667 28.8896 12.4071 29.371C12.7475 29.8525 13.194 30.2493 13.7121 30.5307C14.2303 30.8122 14.8061 30.9707 15.3953 30.9942C15.9845 31.0176 16.5712 30.9054 17.11 30.666L20 29.383L22.89 30.666C23.4289 30.9054 24.0156 31.0176 24.6047 30.9942C25.1939 30.9707 25.7698 30.8122 26.2879 30.5307C26.806 30.2493 27.2526 29.8525 27.5929 29.371C27.9333 28.8896 28.1585 28.3363 28.251 27.754L29.937 18.966C30.0488 18.257 30.0114 17.5325 29.8274 16.8388C29.6433 16.145 29.3166 15.4973 28.868 14.937V14.937Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgApple);
export default ForwardRef;
